
export function capitalizeFirst(str: string) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatTimestamp(timestamp: number | string | Date): string {
    const date = new Date(timestamp);

    const day: string = String(date.getDate()).padStart(2, '0');
    const month: string = String(date.getMonth() + 1).padStart(2, '0');
    const year: string = String(date.getFullYear()).slice(-2);

    const hours: string = String(date.getHours()).padStart(2, '0');
    const minutes: string = String(date.getMinutes()).padStart(2, '0');
    const seconds: string = String(date.getSeconds()).padStart(2, '0');

    return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds}`;
}

export function getFormattedDate(timestamp: number | string | Date): string {
    const date = new Date(timestamp);

    const day: string = String(date.getDate()).padStart(2, '0');
    const month: string = String(date.getMonth() + 1).padStart(2, '0');
    const year: string = String(date.getFullYear());

    return `${day}.${month}.${year}`;
}

export function getFormattedTime(timestamp: number | string | Date): string {
    const date = new Date(timestamp);

    const hours: string = String(date.getHours()).padStart(2, '0');
    const minutes: string = String(date.getMinutes()).padStart(2, '0');
    const seconds: string = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}

export function getReadableDate(timestamp: number | string | Date): string {
    const date = new Date(timestamp);
    const formatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };

    return date.toLocaleDateString('en-US', formatOptions);
}


type LocationId = "binance" | "coinbase" | "kraken" | "ethereum" | string;

interface EthereumMapping {
    address: string;
    symbol: string;
}

interface EthereumMapping {
    address: string;
    symbol: string;
}

export const ethereumMappings: EthereumMapping[] = [
    { address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9", symbol: "AAVE" },
    { address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52", symbol: "BNB" },
    { address: "0xD533a949740bb3306d119CC777fa900bA034cd52", symbol: "CRV" },
    { address: "0x6B175474E89094C44Da98b954EedeAC495271d0F", symbol: "DAI" },
    { address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", symbol: "ETH" },
    { address: "0x6810e776880C02933D47DB1b9fc05908e5386b96", symbol: "GNO" },
    { address: "0x514910771AF9Ca656af840dff83E8264EcF986CA", symbol: "LINK" },
    { address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0", symbol: "MATIC" },
    { address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2", symbol: "MKR" },
    { address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933", symbol: "PEPE" },
    { address: "0x111111111117dC0aa78b770fA6A738034120C302", symbol: "1INCH" },
    { address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF", symbol: "ALCX" },
    { address: "0xba100000625a3754423978a60c9317c58a424e3D", symbol: "BAL" },
    { address: "0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C", symbol: "BNT" },
    { address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53", symbol: "BUSD" },
    { address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B", symbol: "CVX" },
    { address: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c", symbol: "ENJ" },
    { address: "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0", symbol: "FXS" },
    { address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32", symbol: "LDO" },
    { address: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f", symbol: "RPL" },
    { address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F", symbol: "SNX" },
    { address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6", symbol: "STG" },
    { address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2", symbol: "SUSHI" },
    { address: "0x0f2D719407FdBeFF09D87557AbB7232601FD9F29", symbol: "SYN" },
    { address: "0x0000000000085d4780B73119b644AE5ecd22b376", symbol: "TUSD" },
    { address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1", symbol: "USDP" },
    { address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e", symbol: "YFI" },
    { address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498", symbol: "ZRX" },
    { address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D", symbol: "RENBTC" },
    { address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51", symbol: "SUSD" },
    { address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984", symbol: "UNI" },
    { address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", symbol: "USDC" },
    { address: "0xdAC17F958D2ee523a2206206994597C13D831ec7", symbol: "USDT" },
    { address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c", symbol: "EURC" },
    { address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2", symbol: "WETH" },
    { address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599", symbol: "WBTC" },
    { address: "0x853d955aCEf822Db058eb8505911ED77F175b99e", symbol: "FRAX" },
    { address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0", symbol: "LUSD" },
    { address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3", symbol: "MIM" },
    { address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd", symbol: "GUSD" },
    { address: "0x865377367054516e17014CcdED1e7d814EDC9ce4", symbol: "DOLA" },
    { address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E", symbol: "CRVUSD" },
    { address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3", symbol: "USDE" },
    { address: "0x0C10bF8FcB7Bf5412187A595ab97a3609160b5c6", symbol: "USDD" },
    { address: "0xdB25f211AB05b1c97D595516F45794528a807ad8", symbol: "EURS" },
    { address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8", symbol: "AGEUR" },
];


// Utility function
export function universalAddressToSymbol(asset: string): string {
    const [location, value] = asset.split(":");

    switch (location.toLowerCase()) {
        case "binance":
        case "coinbase":
        case "kraken":
            return (value ?? asset).toUpperCase();

        case "ethereum": {
            const found = ethereumMappings.find(
                (m) => m.address.toLowerCase() === value.toLowerCase()
            );
            return (found ? found.symbol : value ?? asset).toUpperCase();
        }

        default:
            return (value ?? asset).toUpperCase();
    }
}


export const getAccountTypeFromAddress = (address: string) => {
    if (!address || typeof address !== 'string') {
        return 'Unknown';
    }

    const location = address.split(':')[0];

    switch (location) {
        case 'binance':
        case 'kraken':
        case 'coinbase':
            return 'Exchange';
        case 'ethereum':
            return 'Wallet';
        case 'aggregated_all':
            return 'Combined (all)';
        default:
            if (location.startsWith('aggregated_')) {
                const actualLocation = location.replace('aggregated_', '');
                return `Combined (${actualLocation})`;
            }
            return 'Unknown';
    }
};